import type { Models } from 'Types/model';

const OTHER_MODEL = 'other';

export const sortModels = (options: Models = []): Models =>
	[...options].sort((a, b) => {
		if (a?.namePretty?.toLowerCase()?.includes(OTHER_MODEL)) {
			return 1;
		}
		if (b?.namePretty?.toLowerCase()?.includes(OTHER_MODEL)) {
			return -1;
		}
		return a.namePretty.localeCompare(b.namePretty);
	});
